import {createAsyncThunk} from "@reduxjs/toolkit";
import { getRecentSearches } from "../recentSearchService";
import {getSavedSearches} from "../savedSearchService";

// Create a thunk that will be called when the component mounts
export const loadSearchMetaData = createAsyncThunk(
  'enhancedSearch/loadSearchMetaData',
  async () => {
    try {
      return {
          recentSearches: getRecentSearches(),
          savedSearches: getSavedSearches(),
      };
    } catch (error) {
      return { };
    }
  }
);